import { Box } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
    first?: boolean;
    readOnly?: boolean;
};

export const OrbitFormSection = ({ children, first, readOnly }: Props) => (
    <Box
        sx={{
            mt: first ? 0 : 3,
            pt: first ? 0 : 3,
            borderTop: first ? 'none' : '1px solid',
            borderColor: 'divider',
        }}
    >
        <Box
            component={readOnly ? 'fieldset' : 'div'}
            disabled={readOnly}
            sx={{ border: 0, m: 0, p: 0, minWidth: 0 }}
        >
            {children}
        </Box>
    </Box>
);
